import {atom} from 'recoil';

export const confirmState = atom({
    key: 'confirmState',
    default: {
        active: false,
        text: '',
        onConfirm:()=>{}
    }
});